import gql from "graphql-tag";

export default gql`
  query inventoryDiagnostics($input: InventoryDiagnosticsInput) {
    inventoryDiagnostics(input: $input) {
      totalCount
      nodes {
        inventoryId
        shopId
        productId
        variantId
        productNumber
        title
        description
        salesDescription
        vendor
        slug
        productIsVisible
        productIsDeleted
        backendAvailable
        publishableForShop
        serialNumber
        limesId
        virtualProductSuffix
        storage
        variantIsVisible
        variantIsDeleted
        variantStatus
        technicalStatus
        sellStatus
        showOnPricelist
        price
        inventoryInStock
        expectedInventoryInStock
        inventoryReserved
        expectedReserved
        expectedReservedCurrentCode
        currentAvailableToSell
        expectedAvailableToSell
        canBackorder
        orderReserved
        orderIds
        activeReservationQuantity
        activeReservationCount
        reservationIds
        catalogId
        catalogProductIsVisible
        catalogProductIsSoldOut
        catalogGroupIsSoldOut
        catalogGroupAvailableToSell
        reservedMismatch
        inventoryMismatch
        reservedMismatchVsCurrentCode
        reservedTooHigh
        blockedByCurrentReserved
        catalogMissing
        catalogVariantMissing
        catalogHasNoGroups
        catalogGroupMissing
        catalogProductInvisible
        catalogProductSoldOut
        catalogGroupSoldOut
        issues
        fixDescription
        interfaceLogs {
          source
          operation
          status
          message
          previousInventoryInStock
          inventoryInStock
          isAvailable
          createdAt
        }
      }
    }
  }
`;
